// Copyright 2025. WebPros International GmbH. All rights reserved.

export const TABLE_ACTIONS = {
    EDIT: 'edit',
    REMOVE: 'remove',
};
export const ICONS = {
    TYPE_FILTER: 'icon-type-filter',
};